import {
  DASHBOARDKEYSEARCH,
  SET_FINANCIAL_YEAR,
} from "../../actions-Types/actionTypes";

export const setDashboardSearchKey = (value: string) => ({
  type: DASHBOARDKEYSEARCH,
  payload: value,
});

export const setFinancialYear = (startDate: string, endDate: string) => ({
  type: SET_FINANCIAL_YEAR,
  payload: { startDate, endDate },
});
